import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-demo-banner',
  templateUrl: './demo-banner.component.html',
  styleUrls: ['./demo-banner.component.css'],
})
export class DemoBannerComponent implements OnInit {
  isDemo = window.location.hostname.includes('demo');

  ngOnInit(): void {
    if (this.isDemo) {
      document.documentElement.classList.add('is-demo');
    }
  }
}
